import React, { Component } from 'react';
import { Link } from 'react-router';
import './pressList.css';
import { Helmet } from 'react-helmet';

export default class WordList extends Component {
    constructor(props) {
        super(props)
        // this.bishun_data = window.AllBooksForPress;
        this.bishun_data = [];
        // console.log(this.bishun_data);
        this.state = {
            srcString: 'http://www.gankao.com/p-lubo/tag/tbsz',
            current: 1,
        }
    }

    componentDidMount() {
        this.getPressList();
    }
    getPressList = () => {
        fetch('https://www.gankao.com/api/newWord/press', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then(res => res.json())
            .then(data => {
                // console.log("获取出版社列表成功:", data);
                if (data && data.status === 200) {
                    this.bishun_data = data.data;
                    this.setState({});
                }
            })
            .catch(err => {
                console.log('获取出版社列表失败:', err);
            });
    }

    render() {
        // console.log("this.props.children........", this.props.children)
        let { srcString } = this.state;
        return (
            <div className="bookListBox">
                <Helmet>
                    <title>
                        笔顺书法
                    </title>
                </Helmet>
                {this.props.children && this.props.children}
                {!this.props.children &&
                    <div>
                        {this.bishun_data.map((item, index) => {
                            // console.log(item, 111);
                            return <Link key={"press" + index} to={`/press/${item.pinyin}`}>
                                <div className="pressItem">
                                    {item.name}
                                </div>
                            </Link>
                        })}
                    </div>
                }
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/press_list/PressList.js